import React from 'react';
import { Link } from 'react-router-dom';

import './EmailConfirmation.css';

function EmailConfirmation(props) {
  const renderConfirmation = () => {
    if (props.confirmed) {
      return (
        <div className="alert alert-success" role="alert">
          Your email has been confirmed!
        </div>
      );
    }

    if (props.error) {
      return (
        <div className="alert alert-danger" role="alert">
          {typeof props.error === 'string' ? props.error : 'Unexpected error. Click the link from an email.'}
        </div>
      );
    }

    return (
      <div className="d-inline-block w-25">
        <div className="progress">
          <div className="progress-bar w-100 progress-bar-striped progress-bar-animated" role="progressbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100" />
        </div>
      </div>
    );
  };

  return (
    <form className="form-signin text-center">
      {renderConfirmation()}

      <div className="form-box form-box-small">
        <Link to="/login">Go back to login</Link>
      </div>
    </form>
  );
}

export default EmailConfirmation;
